import React from 'react';
import { Box, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { Title } from 'react-admin';
import { AgentCostTiles } from './AgentCostTiles';
import { DefinitionEditor } from './DefinitionEditor';
import { OrgTree } from './OrgTree';
import { useAgentOrg } from './useAgentOrg';

// Écran « Organisation & agents » : l'organigramme (identique pour tous les clients)
// et, pour chaque rôle, la définition que Quanti y écrit.
// #region AgentsOrgScreen
export const AgentsOrgScreen: React.FC = () => {
	const { roles, selected, setSelected, detail, loading, saving, save, reset } = useAgentOrg();

	return (
		<Box sx={{ p: 2 }}>
			<Title title="Agents IA" />
			<Typography variant="h5" gutterBottom>
				Agents IA — organisation
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
				L'organigramme est le même pour tous les clients : un client active ou met en pause ses agents, il ne
				change pas la structure. Ici on écrit ce que chaque agent est (sa mission), ce qu'il surveille par défaut
				(ses actions) et comment il planifie.
			</Typography>
			{loading ? (
				<CircularProgress />
			) : (
				<Grid container spacing={2}>
					<Grid item xs={12} md={4}>
						<Card>
							<CardContent sx={{ p: 0 }}>
								<OrgTree roles={roles} selected={selected} onSelect={setSelected} />
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={12} md={8}>
						<Card>
							<CardContent>
								{detail ? (
									<DefinitionEditor detail={detail} saving={saving} onSave={save} onReset={reset} />
								) : (
									<CircularProgress size={24} />
								)}
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			)}
			<AgentCostTiles />
		</Box>
	);
};
// #endregion
